import { DateTime } from 'luxon';
import { ElegibilidadeLancamentoNovaHome, ModalidadePeriodo, TipoCurso } from './elegibilidade-aluno-nova-home.types';

const elegibilidadeLancamentoNovaHome: ElegibilidadeLancamentoNovaHome = {
  fases: [
    {
      fase: 1,
      habilitarAPartirDe: '10/02/2026', // substitir pela data real
      modo: 'SEGMENTADO',
      segmentacoes: [
        {
          marcas: ['estacio'],
          tipoCurso: [TipoCurso.GRADUACAO],
          modalidade: [ModalidadePeriodo.SEMI, ModalidadePeriodo.FLEX],
          periodo: ['2026.1'],
          codigoCurso: ['7022', '7024'],
        },
        {
          marcas: ['estacio'],
          tipoCurso: [TipoCurso.GRADUACAO_TECNOLOGICA],
          modalidade: [ModalidadePeriodo.EAD],
          periodo: ['2026.1'],
          codigoCurso: ['4070', '4389', '4334', '3631'],
        },
        {
          marcas: ['estacio'],
          tipoCurso: [TipoCurso.ESPECIALIZACAO],
          modalidade: [ModalidadePeriodo.EAD],
          periodo: ['2026.1'],
          codigoCurso: ['3592'],
        },
        {
          marcas: ['wyden'],
          tipoCurso: [TipoCurso.GRADUACAO_TECNOLOGICA],
          modalidade: [ModalidadePeriodo.EAD],
          periodo: ['2026.1'],
          codigoCurso: ['4340'],
        },
        {
          marcas: ['wyden'],
          tipoCurso: [TipoCurso.ESPECIALIZACAO],
          modalidade: [ModalidadePeriodo.EAD],
          periodo: ['2026.1'],
          codigoCurso: ['3629'],
        },
        {
          marcas: ['ibmec'],
          tipoCurso: [TipoCurso.GRADUACAO],
          modalidade: [ModalidadePeriodo.PRESENCIAL],
          periodo: ['2026.1'],
          codigoCurso: ['19'],
        },
      ],
    },
    {
      fase: 2,
      habilitarAPartirDe: '', // substituir pela data real
      modo: 'SEGMENTADO',
      segmentacoes: [
        // segmentações fase 2
      ],
    },
    {
      fase: 3,
      habilitarAPartirDe: '', // substituir pela data real
      modo: 'SEGMENTADO',
      segmentacoes: [
        // segmentações fase 3
      ],
    },
    {
      fase: 4,
      habilitarAPartirDe: '', // substituir pela data real
      modo: 'TODOS',
    },
  ],
};
export const getElegibilidadeAlunoNovaHome = ({ ambiente }: { ambiente: string }): ElegibilidadeLancamentoNovaHome => {
  if (ambiente === 'dev' || ambiente === 'local') {
    return {
      fases: [
        {
          fase: 1,
          habilitarAPartirDe: DateTime.now().minus({ day: 1 }).toFormat('dd/MM/yyyy'),
          modo: 'TODOS',
        },
      ],
    };
  }

  return elegibilidadeLancamentoNovaHome;
};
